import { render, staticRenderFns } from "./CmgGroupOrderJoin.vue?vue&type=template&id=60024144&scoped=true&lang=pug&"
import script from "./cmg-group-order-join.ts?vue&type=script&lang=ts&"
export * from "./cmg-group-order-join.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGroupOrderJoin.vue?vue&type=style&index=0&id=60024144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60024144",
  null
  
)

export default component.exports